import React from "react";
import { Button, PanelActions, PanelDialog, PanelHeading, PanelRow } from "@backslashbuild/pp-ui";
import { usePost } from "./api";
import { publish } from "../../pubSub";

export default function UpdateAgencyMappingButton() {
  const [dialogOpen, setDialogOpen] = React.useState(false);
  const updateMapping = usePost("agencies/index/put");

  function handleClose() {
    setDialogOpen(false);
  }

  async function handleClick() {
    publish("notification", "Updating the agency index mapping...");

    handleClose();

    const result = await updateMapping();

    if (!result.isSuccess) {
      var errors = result?.errors;
      publish(
        "notification",
        <ul>
          Unable to update agency index mapping. Errors:
          {errors?.length > 0 &&
            errors?.map((error) => {
              return <li>{error}</li>;
            })}
        </ul>
      );
      return;
    }

    if (result?.isSuccess) publish("notification", "Remapping completed.");
  }

  return (
    <>
      <Button small onClick={() => setDialogOpen(true)} style={{ width: 200 }}>
        Remap Agencies Index
      </Button>
      <PanelDialog onClose={handleClose} open={dialogOpen}>
        <PanelHeading>Update Agencies Index Mapping</PanelHeading>
        <PanelRow>
          <div>Are you sure you want to update the agencies index mapping?</div>
        </PanelRow>
        <PanelActions>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleClick}>
            Reset
          </Button>
        </PanelActions>
      </PanelDialog>
    </>
  );
}
